import Translations from '../../components/Translations';
import React, {
    useEffect,
    useState,
} from 'react';
import {
    connect,
} from 'react-redux';
import {
    Grid,
    Dropdown,
    Loader,
    Image,
    Header,
} from 'semantic-ui-react';
import _ from 'lodash';

import noResultLogo from '../../assets/no_result_icon.png';

import {
    handleGetCoveragesHistory,
} from '../../actions';
import HELPER_FUNCTION_UTILITY from '../../utils/helper';
import HistoryPageProduct from '../../components/history_page/product';

const HistoryPage = (props) => {

    const [selectedBenefitPeriodKey, setSelectedBenefitPeriodKey] = useState(null);

    useEffect(() => {
        (async() => {
            props.handleGetCoveragesHistory({}, (error) => {
                console.warn(error);
            });
        })();
    }, [props.config]);

    useEffect(() => {
        if (props.benefitPeriods && selectedBenefitPeriodKey === null && !_.isEmpty(props.benefitPeriods)) {
            console.log('load default BP value key', props.benefitPeriods);
            const options = getBenefitPeriodOptions(props.benefitPeriods);
            setSelectedBenefitPeriodKey(options[0].value);
        }
    }, [props.benefitPeriods]);

    if (!props.isLoaded) {
        return (
            <Loader active />
        );
    }

    const renderProducts = () => {

        const {
            products,
            coverages,
            config,
        } = props;

        if (_.isEmpty(props.benefitPeriods)) {
            return (
                <div>
                    <Image src={noResultLogo} size="medium" centered />
                    <Header as="h3"><Translations text="selection.history_empty_title" backup={"We're Sorry"} /><Header.Subheader><Translations text="selection.history_empty_description" backup={"No past selection data could be found"} /></Header.Subheader>
                    </Header>
                </div>
            );
        }

        if (selectedBenefitPeriodKey) {
            const targetProducts = products[selectedBenefitPeriodKey];
            const targetCoverages =coverages[selectedBenefitPeriodKey];
            return _.map(
                _.keys(targetProducts),
                (pKey) => {
                    return (
                        <HistoryPageProduct 
                            key={pKey}
                            productKey={pKey}
                            product={targetProducts[pKey]}
                            coverages={HELPER_FUNCTION_UTILITY.extractCoveragesByProductKey(targetCoverages, pKey)}
                            family={config.family}
                            currencyMinorUnit={config.currencyMinorUnit}
                            currency={config.showBaseCurrency ? config.currency : ''}
                        />
                    );
                }
            )
        }
    }

    return (
        <React.Fragment>
            <Grid container centered stackable columns={1} padded="vertically">
                <Grid.Column>
                    <Translations text="walletbalancewidget.benefitperiod" backup="Benefit Period" render={placeholder => (
                    <Dropdown 
                        placeholder={placeholder}
                        fluid
                        options={getBenefitPeriodOptions(props.benefitPeriods)}
                        selection
                        value={selectedBenefitPeriodKey}
                        onChange={(event, data) => setSelectedBenefitPeriodKey(data.value)}
                    />
                    )} />
                </Grid.Column>
            </Grid>
            <div style={{backgroundColor: "#EFEFEF", minHeight: '100vh',}}>
                <Grid container centered stackable columns={1} padded="vertically">
                    {renderProducts()}
                </Grid>
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        isLoaded: state.coverages.history.loaded,
        config: state.config,
        products: state.coverages.history.products,
        coverages: state.coverages.history.coverages,
        benefitPeriods: state.coverages.history.benefitPeriods,
    };
};

export default connect(mapStateToProps, {
    handleGetCoveragesHistory,
})(HistoryPage);


const getBenefitPeriodOptions = (benefitPeriods) => {
    return _.map(
        _.keys(benefitPeriods),
        (k) => {
            const bp = benefitPeriods[k];
            return {
                key: k,
                text: bp.name,
                value: k,
            };
        },
    );
};
